import type { ReactNode } from "react";

import { kcalSpoken, kcalText } from "../domain/foodView";

/**
 * A food's kcal, with the "~" of an estimated dish (SNIPPETS §39) — the INDB rows, whose figure is
 * the table's usual recipe. The "~" is the figure's own colour and weight, so it sits inside
 * whatever styles the figure; a screen reader hears "about 328 kcal, estimated" instead of a
 * tilde. Never for a total: a meal, day or hero total is a sum, and would always read "~".
 */
export function Kcal({ kcal, estimated }: { kcal: number; estimated: boolean }) {
  // A no-break space: "~328" and "kcal" wrapped onto two lines read as two values.
  const shown = kcalText(kcal, estimated).replace(" kcal", " kcal");
  if (!estimated) return <>{shown}</>;
  return (
    <>
      <span aria-hidden="true">{shown}</span>
      <span className="k-sr">{kcalSpoken(kcal, true)}</span>
    </>
  );
}

/** The one line that says what "~" means, on any screen that shows one. */
export function EstimateLegend({ children }: { children: ReactNode }) {
  return (
    <p className="k-est-legend">
      <span className="k-est-legend__mark" aria-hidden="true">
        ~
      </span>
      <span>{children}</span>
    </p>
  );
}
